export const MARGINS = { top: 16, right: 16, bottom: 16, left: 16 };

export const DARK_COLORS = ['#4318ff'];
export const LIGHT_COLORS = ['#eff4fb', '#6ad2ff', '#c3edff'];

export const COLORS = [...DARK_COLORS, ...LIGHT_COLORS];
export const NUM_OF_COLORS = COLORS.length;

export const LABEL_COLOR_DARK = '#2B3674';
export const LABEL_COLOR_LIGHT = '#FFFFFF';

export const THEME = {
  labels: {
    text: {
      fontSize: 18,
      fontWeight: 'bold',
    },
  },
};
